export const UNIT_LIST_REQUEST = 'UNIT_LIST_REQUEST'
export const UNIT_LIST_SUCCESS = 'UNIT_LIST_SUCCESS'
export const UNIT_LIST_FAILURE = 'UNIT_LIST_FAILURE'